import { Pill } from '@mantine/core';
import { useIntl } from 'react-intl';

import { notificationUpdatesPickerMessages } from './notification-updates-picker-messages';
import { NOTIFICATION_TYPE_OPTIONS } from './notifications-section-messages';
import { Tag } from '../../../tag/tag';

import type { FreightNotificationType } from '../../../../types/freight-responses';

export type NotificationTypePillsProps = {
  types: FreightNotificationType[];
  onRemove?: (type: FreightNotificationType) => void;
  'data-testid'?: string;
};

export const NotificationTypePills = ({ types, onRemove, 'data-testid': dataTestId }: NotificationTypePillsProps) => {
  const intl = useIntl();

  return (
    <Pill.Group data-testid={dataTestId}>
      {NOTIFICATION_TYPE_OPTIONS.filter((option) => types.includes(option.value)).map((option) => {
        const label = intl.formatMessage(option.label);
        return (
          <Tag.System
            key={option.value}
            color='light'
            onRemove={onRemove ? () => onRemove(option.value) : undefined}
            removeAriaLabel={onRemove ? intl.formatMessage(notificationUpdatesPickerMessages.removeUpdate, { label }) : undefined}
            withRemoveButton={Boolean(onRemove)}
          >
            {label}
          </Tag.System>
        );
      })}
    </Pill.Group>
  );
};
